import React, { useState, useEffect } from 'react';
import C from 'classnames';
import PropTypes from 'prop-types';
import * as amazonConnect from 'services/connectService';

const Connect = ({
  isOpen,
  phoneNumber,
  patientGuid,
  setCallId,
  isRpmCall,
  deviceId,
  readingId,
  windowExpanded,
  wsClient,
}) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (isOpen && !initialized) {
      amazonConnect.init(
        phoneNumber,
        patientGuid,
        setCallId,
        isRpmCall,
        deviceId,
        readingId,
        wsClient,
      );
      setInitialized(true);
    }

    if (!isOpen && initialized) {
      amazonConnect.terminate();
      setInitialized(false);
    }
  }, [isOpen, phoneNumber]);

  return (
    <div
      className={C('connect', windowExpanded ? 'expanded' : 'collapsed')}
      id="connect-el"
    />
  );
};

Connect.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  phoneNumber: PropTypes.string,
  patientGuid: PropTypes.string.isRequired,
  setCallId: PropTypes.func,
  isRpmCall: PropTypes.bool,
  deviceId: PropTypes.string,
  readingId: PropTypes.string,
  windowExpanded: PropTypes.bool,
  wsClient: PropTypes.object,
};

export default Connect;
